"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FLEX_GRID_TYPES = exports.FLEX_ALIGN_ITEMS = void 0;
var STRETCH = 'stretch';
var START = 'start';
var FLEX_START = 'flex-start';
var SELF_START = 'self-start';
var END = 'end';
var FLEX_END = 'flex-end';
var SELF_END = 'self-end';
var CENTER = 'center';
var BASELINE = 'baseline';
var FLEX_ALIGN_ITEMS = exports.FLEX_ALIGN_ITEMS = {
  STRETCH: STRETCH,
  START: START,
  FLEX_START: FLEX_START,
  SELF_START: SELF_START,
  END: END,
  FLEX_END: FLEX_END,
  SELF_END: SELF_END,
  CENTER: CENTER,
  BASELINE: BASELINE
};
var FLEX_GRID_TYPES = exports.FLEX_GRID_TYPES = {
  SECTIONS: 'SECTIONS',
  LINES: 'LINES'
};